import {
  Form,
  FormItem,
  Input,
  Row,
  Col,
  Tooltip,
  Button,
  Select,
  Option,
  Dialog,
} from "element-ui";
import { mapState } from "vuex";
import { omit } from "lodash";
import isMobile from "@/shared/utils/isMobile";
import { formatNumberFractionDigits } from "@/shared/utils/formatNumber.js";
import styles from "./index.less?module";

const StopSignalBaseInfo = {
  data() {
    return {
      formVal: {
        portfolioName: "",
        shareProfitPercent: null,
        settlementPeriodType: null,
        createTime: "",
      
      },
      enableStatus: 0,
      enableControlStatus: 0,
      switchLoading: false,
      shareProfitPercentDisabled: true,
      detailInfo: {},
      settlementPeriodTypeStatus: 1,
      shareProfitPercentStatus: 1,
      isDisabledDialog: false,
    };
  },
  computed: {
    ...mapState(["checkPortfolio"]),
  },
  created() {
    this.getBaseInfo();
  },
  methods: {
    formatNumberFractionDigits,
    // 获取信号源基本信息
    getBaseInfo() {
      const loading = this.$loading({
        lock: true,
      });
      this.$axios
        .get("/api/Portfolio/GetPortfolioDetail", {
          params: { id: this.checkPortfolio.id },
        })
        .then((res) => {
          let dt = res.data;
          if (dt.isSuccess) {
            this.detailInfo = dt.result;
            this.formVal = omit(dt.result, [
              "settlementPeriodTypeTitle",
              "deleteBtnStatus",
              "enableControlStatus",
              "status",
              "followDirection",
            ]);
            this.enableStatus = dt.result.status;
            this.enableStatusTxt = dt.result.status ? this.$t("Common_EnabledIng") : this.$t("Common_DisabledIng");
          }
        })
        .finally(() => {
          loading.close();
        });
    },
  
    cancelSignal() {
      this.isDisabledDialog = false;
    },
  },

  render() {
    const colSpan = isMobile ? 24 : 12;

    return (
      <div class={{ tableDiv: !isMobile, [styles.h5Container]: isMobile }}>
        <Form
          ref="signalBaseInfoForm"
          labelPosition="top"
          props={{ model: this.formVal }}
          class={styles.signalBaseInfoForm}
        >
          {/* --------------------------信号设置-------------------------- */}
          <div class={styles.formGroupTitle}>
            <div class={styles.diamondIcon} />
            {this.$t("SignalSource_SignalSetting")}
          </div>
          <Row gutter={30}>
            {/* 名称 */}
            <Col span={colSpan}>
              <FormItem label={this.$t("Common_TableTitle_SignalSource")} prop="portfolioName">
                <Input v-model={this.formVal.portfolioName} disabled />
              </FormItem>
            </Col>
            {/* 分润比例 */}
            <Col span={colSpan}>
              <FormItem
                label={this.$t("Common_TableTitle_SignalPLSharingRatio")}
                prop="shareProfitPercent"
                rules={{
                  validator: (_, value, callback) => {
                    if (!`${value}`) {
                      return callback(
                        new Error(this.$t("Common_valid_CheckSignalSharingRatio"))
                      );
                    } else {
                      var reg = /^([0]$)|(^[1-9][0-9]{0,1}|100)$/;
                      if (!reg.test(value)) {
                        callback(new Error(this.$t("Common_Valid_CheckInt100")));
                      } else {
                        callback();
                      }
                    }
                  },
                }}
              >
                <div class={styles.editFormItemWrapper}>
                  <Input
                    v-model={this.formVal.shareProfitPercent}
                    disabled={this.shareProfitPercentStatus == 1}
                    placeholder="0-100"
                  >
                    <template slot="suffix">%</template>
                  </Input>
                  {!this.shareProfitPercentStatus && (
                    <Button
                      type="text"
                      class={styles.editButton}
                      onClick={this.handleShareProfitPercentCLick}
                    >
                      {this.shareProfitPercentStatus
                        ? this.$t("Common_Operation_Edit")
                        : this.$t("Common_Save")}
                    </Button>
                  )}
                </div>
              </FormItem>
            </Col>
          </Row>
      
          <Row gutter={30}>
            {/* 创建时间 */}
            <Col span={colSpan}>
              <FormItem label={this.$t("Common_TableTitle_CreateTime")} prop="createTime">
                <Input v-model={this.formVal.createTime} disabled />
              </FormItem>
            </Col>
             {/* 禁用时间 */}
              <Col span={colSpan}>
                <FormItem label={this.$t("Common_TableTitle_DisabledTime")} prop="updateTime">
                  <Input v-model={this.formVal.updateTime} disabled />
                </FormItem>
              </Col>
          </Row>
        </Form>
      </div>
    );
  },
};

export default StopSignalBaseInfo;
